import React from 'react';
import { FaEye, FaIntercom, FaRadiationAlt } from 'react-icons/fa';
import CopyToClipboard from '../../../../../core/components/CopyToClipboard';
import { urlWebsite } from '../../../../../../../config';
import { useSocket } from '../../../../../../../hooks/Socket';
import { useModal } from '../../../../../../../hooks/Modal';
import Review from '../../../modules/Review';
import api from '../../../../../../../services/api';
import { useLoading } from 'src/hooks/LoadingHook';
import { useToast } from 'src/hooks/Toast';
import { convertToXLSX } from 'src/utils/download';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ListComplete({ configuration }): JSX.Element {

  const { addModal } = useModal();
  const { addLoading, removeLoading } = useLoading();
  const { addToast } = useToast();

  const openReview = async () => {
    addLoading({ title: 'Carregando', key: 'loading' })

    try {
      const avaliations = await api.get(`/cientific-avaliations`, { params: { limitItems: 10000, where: { project_id: configuration?.url } } });


      const submissions = await api.get(`/cientific-submissions`, { params: { limitItems: 10000, where: { project_id: configuration?.url } } });


      const list = [["ID", "Referência", "Categoria", "Area", "Subárea", "Apresentador", "Orientador", "Edital", "Avaliador", "Trabalho", "Data"]]


      avaliations?.data?.rows?.map(i => {

        const submission = submissions?.data?.rows?.find(a => a?._id?.toString() === i?.paper_id_response?._id?.toString());

        list.push([
          i?._id?.toString(),
          i?.reference,
          i?.category,
          i?.area,
          i?.subarea,
          submission?.author,
          i?.orientator,
          i?.selective_id_response?.title,
          i?.avaliator_id_response?.name,
          i?.date,
          i?.paper_id_response?.title,






        ])

      })

      convertToXLSX(list);
      removeLoading('loading');
      addToast({ title: 'Relatório gerado com sucesso', type: 'success' })

    }
    catch (err) {

      console.log(err);
      removeLoading('loading');
      addToast({ title: err?.response?.data?.error || err?.response?.data?.message || 'Erro ao gerar relatório', type: 'error' })

    }

  }


  const moduleCreate = (): JSX.Element => {

    return <div onClick={() => openReview()} className="searchButton">
      <FaEye className="hover" style={{ cursor: 'pointer' }} /></div>;
  }



  return moduleCreate();
}
